import styled from "styled-components";
import { spacing, color, palette, fontWeight } from "@conserveit/blocks";

function isSelected({ active }) {
  const weight = active ? fontWeight.bold : fontWeight.normal;
  return `font-weight: ${weight}`;
}

function isNoMatch({ noMatch }) {
  return noMatch
    ? `
    font-weight: normal;
    color: #dadada;
    opacity: 0.4;
  `
    : "";
}

export const $Project = styled.button.attrs({ type: "button" })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  outline: 0;
  width: 100%;
  /* TODO: hacky  */
  padding: ${spacing.tight} ${spacing.default} !important;
  font-size: 14px;
  line-height: 1;
  text-align: left;
  color: ${color.theme.black};
  ${isSelected};
  ${isNoMatch};
  cursor: pointer;
  background: transparent;

  &:hover {
    background: ${color.theme.supportingColor.tint};
  }

  &:active,
  &:focus {
    outline: 0;
  }
`;

export const $Site = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 ${spacing.default};
  color: ${color.theme.black};
  font-size: 14px;
  line-height: 32px;
  outline: 0;
  border: none;
  background: none;
  ${isNoMatch};

  .Site-label {
    padding-right: ${spacing.default};
    flex-grow: 1;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &:hover {
    background: ${color.theme.supportingColor.tint};
  }
`;

export const $SelectedSite = styled($Site)`
  color: ${palette.blue7};
  font-size: 13px;
  font-weight: bold;

  svg {
    display: none;
    fill: ${palette.blue7};
  }

  &:hover svg {
    display: inline-block;
  }
`;
